import React, { useContext, useRef } from 'react';

import classNames from 'classnames';

import { NavigationContext } from '../../context/NavigationContext';
import { useLockScroll } from '../../hooks/useLockScroll';
import { usePersistentScrollPosition } from '../../hooks/usePersistentScrollPosition';
import { Backdrop } from '../Backdrop';
import { NavigationBottomControls } from '../NavigationBottomControls';

import * as classes from './style.module.scss';

interface Props {
  className?: string;
}

export const Navigation: React.FC<Props> = ({ className, children }) => {
  const navigationRef = useRef<HTMLAreaElement | null>(null);

  const { open, closeNavigation } = useContext(NavigationContext);

  useLockScroll(open);
  usePersistentScrollPosition(navigationRef);

  return (
    <aside
      ref={navigationRef}
      className={classNames(classes.root, className, {
        [classes.open]: open,
      })}
    >
      <div className={classes.container}>{children}</div>
      <NavigationBottomControls />
      <Backdrop visible={open} onClick={closeNavigation} />
    </aside>
  );
};
